class SliderVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");
    this.button = this.querySelector("button");

    this.video.addEventListener("pause", this.handlePause.bind(this));
    this.video.addEventListener("play", this.handlePlay.bind(this));

    this.handleInteraction = this.enableControls.bind(this);

    this.addEventListener("pointerdown", this.handleInteraction);
    this.addEventListener("mouseenter", this.handleInteraction);

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion:reduce)"
    );

    if (this.button) {
      this.button.addEventListener("click", (e) => {
        if (this.video.paused) {
          if (!prefersReducedMotion.matches) {
            this.preventAutoplay = false;
          }
          this.play(true);
        } else {
          this.preventAutoplay = true;
          this.pause();
        }
      });
    }

    if (prefersReducedMotion.matches) {
      this.preventAutoplay = true;
      this.pause();

      this.handlePause();
    } else if (this.video.autoplay && this.video.paused) {
      this.play();
    }
  }

  enableControls() {
    this.video.controls = true;
  }

  play(byUserIntent) {
    if (this.preventAutoplay && !byUserIntent) {
      return;
    }
    this.video.play().catch((err) => {
      this.handlePause();
    });
  }

  pause() {
    this.video.pause();
  }

  stop() {
    this.pause();
    this.video.currentTime = 0;
  }

  handlePause() {
    this.classList.add("slider-video--paused");
  }

  handlePlay() {
    this.classList.remove("slider-video--paused");
  }
}
customElements.define("slider-video", SliderVideo);
